import React from 'react';
import PropTypes from 'prop-types';

const TeltMeeField = ({ record = {} }) => {
    const teltMee = !(record.suspectedcrawler === true || record.blacklistedip === true || record.filtereddoubles === true);
    return (
        <span style={{ color: teltMee ? '#2e7d32' : '#c62828', fontWeight: 600 }}>
            {teltMee ? 'Ja' : 'Nee'}
        </span>
    );
};

TeltMeeField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
};

export default TeltMeeField;



// WEBPACK FOOTER //
// ./src/utils/TeltMeeField.js